import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/eye-background-blue.svg'
import _imports_1 from '@/assets/img/icon/check-background-blue.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("\\ ")
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold mb-4" }, "Tanggal Aktif Kontrak", -1)
const _hoisted_6 = { class: "grid grid-cols-1" }
const _hoisted_7 = { class: "lg:flex items-center gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "required w-1/5" }, "Tanggal Mulai Kontrak", -1)
const _hoisted_9 = { class: "w-4/5" }
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Informasi Trayek"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 mt-1 mb-4" }, "Pastikan trayek yang ditambahkan sesuai dengan ketentuan kontrak dengan partner")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "mt-2",
  style: {"width":"fit-content"}
}
const _hoisted_13 = { class: "blue-white-label" }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center gap-2 mt-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Jenis Trayek:", -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "my-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 border-bottom-grey-4-dashed pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-3/5" }, "TRAYEK"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/5" }, "KELAS"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 lg:flex justify-center" }, "AKSI")
], -1)
const _hoisted_21 = { class: "flex items-center gap-3 py-28px partner-form" }
const _hoisted_22 = { class: "w-3/5" }
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = { class: "w-1/5" }
const _hoisted_25 = { class: "w-1/5" }
const _hoisted_26 = { class: "lg:flex justify-center gap-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mt-2 mb-300px rounded-xl background-grey-2" }
const _hoisted_31 = { class: "py-17px px-16px flex items-center gap-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Daftar PP dan Nopol Bus", -1)
const _hoisted_33 = { class: "text-base text-green font-bold" }
const _hoisted_34 = {
  key: 0,
  class: "px-16px pb-17px pt-3"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_36 = { class: "text-left break-words text-sm" }
const _hoisted_37 = { class: "text-left break-words text-sm" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  key: 3,
  class: "flex items-center justify-end gap-4 mt-4"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Kembali'), -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Simpan Kontrak'), -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_SelectFetchCustom = _resolveComponent("SelectFetchCustom")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form", true)!
  const _component_Card = _resolveComponent("Card")!
  const _component_Details = _resolveComponent("Details")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
      content: _withCtx(() => [
        _createVNode(_component_Form, {
          onSubmit: $setup.onSubmit,
          "initial-values": $setup.initialValues,
          "validation-schema": $setup.schema
        }, {
          default: _withCtx(({ errors, values, setFieldValue, meta }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, { name: "StartDate" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_DatePicker, _mergeProps(field, {
                            masks: {
                      input: 'DD/MM/YYYY'
                    },
                            "min-date": $setup.moment().toDate()
                          }), {
                            default: _withCtx(({ togglePopover }) => [
                              _createVNode(_component_InputText, {
                                id: "start-date",
                                placeholder: "Masukkan tanggal mulai",
                                readonly: true,
                                value: values.StartDate ? `${$setup.moment(values.StartDate.toString()).format('DD/MM/YYYY')}` : values.StartDate,
                                class: _normalizeClass(`input-default`),
                                onClick: togglePopover
                              }, null, 8, ["value", "onClick"])
                            ]),
                            _: 2
                          }, 1040, ["min-date"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(errors.StartDate), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_11,
              ($setup.contractData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.selectedTrayekType === 0 ? 'TRAYEK UMUM' : 'TRAYEK BANDARA'), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", {
                      onClick: ($event: any) => (!$setup.contractData ? $setup.onChangeTrayekType(0, setFieldValue) : ''),
                      class: _normalizeClass(["cursor-pointer", $setup.selectedTrayekType === 0 ? 'blue-white-label' : 'default-label'])
                    }, "TRAYEK UMUM", 10, _hoisted_16),
                    _createElementVNode("div", {
                      onClick: ($event: any) => (!$setup.contractData ? $setup.onChangeTrayekType(1, setFieldValue) : ''),
                      class: _normalizeClass(["cursor-pointer", $setup.selectedTrayekType === 1 ? 'blue-white-label' : 'default-label'])
                    }, "TRAYEK BANDARA", 10, _hoisted_17)
                  ])),
              ($setup.isTrayekOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_Field, { name: "Trayek" }, {
                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                              ($setup.selectedTrayekType === 0)
                                ? (_openBlock(), _createBlock(_component_SelectFetchCustom, _mergeProps({ key: 0 }, field, {
                                    modelValue: field.value,
                                    inputId: "class-input",
                                    endpoint: "/management/v2/Trayeks",
                                    fieldLabel: (v) => v.Name,
                                    selectable: (v) => v.IsActive === true,
                                    clearable: false,
                                    searchFields: ['name'],
                                    placeholder: `Pilih Trayek`,
                                    classname: 'custom-select-icon',
                                    searchCustom: [['TrayekTypeId', '=', [$setup.selectedTrayekTypeId]]],
                                    disabled: false
                                  }), null, 16, ["modelValue", "fieldLabel", "selectable", "searchCustom"]))
                                : _createCommentVNode("", true),
                              ($setup.selectedTrayekType === 1)
                                ? (_openBlock(), _createBlock(_component_SelectFetchCustom, _mergeProps({ key: 1 }, field, {
                                    modelValue: field.value,
                                    inputId: "class-input",
                                    endpoint: "/management/v2/Trayeks",
                                    fieldLabel: (v) => v.Name,
                                    selectable: (v) => v.IsActive === true,
                                    clearable: false,
                                    searchFields: ['name'],
                                    placeholder: `Pilih Trayek`,
                                    classname: 'custom-select-icon',
                                    searchCustom: [['TrayekTypeId', '=', [$setup.selectedTrayekTypeId]]],
                                    disabled: false
                                  }), null, 16, ["modelValue", "fieldLabel", "selectable", "searchCustom"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(errors.Trayek), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(values.Trayek?.MsClassName ?? values.Trayek?.ClassName), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "detail",
                                title: "Detail Trayek",
                                class: "cursor-pointer mb-2 lg:mb-0",
                                style: {"width":"35px","height":"35px"},
                                onClick: ($event: any) => (values?.Trayek ? $setup.showDetailTrayek(values.Trayek) : '')
                              }, null, 8, _hoisted_27)
                            ]),
                            ($setup.contractData)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: "save",
                                    title: "Simpan Trayek",
                                    class: "cursor-pointer mb-2 lg:mb-0",
                                    style: {"width":"35px","height":"35px"},
                                    onClick: ($event: any) => ($setup.onSubmit(values))
                                  }, null, 8, _hoisted_29)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", {
                          class: "cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isDetailOpen = !$setup.isDetailOpen))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(`pi pi-angle-${$setup.isDetailOpen ? 'down' : 'right'}`)
                          }, null, 2)
                        ]),
                        _hoisted_32,
                        _createElementVNode("div", _hoisted_33, _toDisplayString(`(${$setup.filters.totalRecords} PP)`), 1)
                      ]),
                      ($setup.isDetailOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createVNode(_component_DataTable, {
                              value: $setup.dataSourceDetail,
                              class: "trayek-list-detail"
                            }, {
                              empty: _withCtx(() => [
                                _hoisted_35
                              ]),
                              loading: _withCtx(() => [
                                _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  header: "Jam PP",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("p", _hoisted_36, _toDisplayString(data?.DepartureTime), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Nopol",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("p", _hoisted_37, _toDisplayString(data.VehicleRegNumber), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Aktif/Nonaktif",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_component_InputSwitch, {
                                        modelValue: data.IsSelected,
                                        "onUpdate:modelValue": [($event: any) => ((data.IsSelected) = $event), ($event: any) => ($setup.onSelectDetailAct(data))]
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_Paginator, {
                              class: "trayek-pagination",
                              rows: $setup.filters.pageSize,
                              totalRecords: $setup.filters.totalRecords,
                              onOnPage: $setup.onChangePage
                            }, null, 8, ["rows", "totalRecords", "onOnPage"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!$setup.contractData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_Button, {
                      class: "flex gap-2 extra-submit-button",
                      outlined: true,
                      onClick: $setup.closeForm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      type: "submit",
                      class: "mb-2 sm:mb-0 flex gap-2"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _hoisted_42
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "initial-values", "validation-schema"])
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    ($setup.showTrayekDetailDialog)
      ? (_openBlock(), _createBlock(_component_Details, {
          key: 0,
          show: $setup.showTrayekDetailDialog,
          data: $setup.dataRow,
          onHideDialog: $setup.closeTrayekDetailDialog
        }, null, 8, ["show", "data", "onHideDialog"]))
      : _createCommentVNode("", true),
    ($setup.showConfirmDialog)
      ? (_openBlock(), _createBlock(_component_HjpConfirmationModal, {
          key: 1,
          show: $setup.showConfirmDialog,
          title: $setup.confirmDialogDelete?.title,
          subTitle: $setup.confirmDialogDelete?.subTitle,
          btnSubmitTitle: $setup.confirmDialogDelete?.btnSubmitTitle,
          onHideDialog: $setup.hideDialogConfirmation,
          onOnSubmit: _ctx.submitFromDialog
        }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"]))
      : _createCommentVNode("", true)
  ]))
}